import {
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useContext, useState } from "react";
import { Button } from "../../../controls";
import { Alert, Dialog, Table } from "../../../layout";
import AddEditReq from "./AddEditReq";
import { connect } from "react-redux";
import * as actions from "../../../api/actions/actions";
import { useEffect } from "react";
import { AppContext } from "../../../App";
import { controller, endpoints } from "../../../api/actions/api";
import { DropLi } from "../../../hooks";
import { useNavigate } from "react-router-dom";

const Requests = (props) => {
  const { _getByObj, _hoa, _delete, unit } = props;
  const { ReqType } = DropLi();
  const [updData, setUpdData] = useState();
  const navigate = useNavigate();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [reqs, setReqs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const { setLoader } = useContext(AppContext);
  useEffect(() => {
    const onComplete = (res) => {
      setLoader(false);
      res.status === 200 && setReqs([...res.result]);
    };
    if (unit && unit.id) {
      _getByObj(
        endpoints.Request + controller.GetAllByUnit,
        { id: unit.id, value: "1" },
        null,
        onComplete
      );
    } else if (_hoa.id) {
      setLoader(true);
      _getByObj(
        endpoints.Request + controller.GetByHoa,
        { id: _hoa.id, value: "1" },
        null,
        onComplete
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa, unit]);

  const handleView = (val) => {
    navigate(`/my_account/view_request/${val.id}`);
  };

  const handleAddEdit = (val) => {
    setUpdData(val);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this request?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setReqs((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        _delete(endpoints.Request, id, null, onComplete);
      },
    });
  };

  const ActionComp = (props) => (
    <>
      <Tooltip arrow title="View Request">
        <IconButton
          onClick={() => handleView(props)}
          size="small"
          color="primary"
          className="btn-error"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      {props.isComplete === 2 && (
        <>
          <Tooltip arrow title="Edit Record">
            <IconButton
              onClick={() => handleAddEdit(props)}
              size="small"
              color="primary"
              className="mr-5"
            >
              <EditRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title="Delete Record">
            <IconButton
              onClick={() => handleDlt(props.id)}
              size="small"
              color="error"
            >
              <ClearRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
        </>
      )}
    </>
  );

  const HeaderComp = () => (
    <div>
      <Button variant="outlined" onClick={() => handleAddEdit()}>
        Add Request
      </Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: "Actions" },
          { id: "status", label: "Status" },
          { id: "unitName", label: "Unit" },
          { id: "reqType", label: "Request Type" },
          { id: "cmpltDate", label: "Complete Date" },
          { id: "created", label: "Created" },
        ]}
        tblData={reqs.map((req) => {
          var type = ReqType.find((j) => j.id === req.type);
          return {
            ...req,
            unitName: req.unit && req.unit.title,
            reqType: type && type.label,
            status:
              req.isComplete === 2 ? (
                <span className="bg-warningT warning-color status">
                  Pending
                </span>
              ) : (
                <span className="bg-primarySM primary-color status">
                  Complete
                </span>
              ),
            created: req.owner ? (
              <div className="d-grid">
                <span>{req.owner.fullName}</span>
                <span className="fs-12">Unit Owner | {req.createDate}</span>
              </div>
            ) : (
              req.createUser && (
                <div className="d-grid">
                  <span>{req.createUser.fullName}</span>
                  <span className="fs-12">
                    Administration | {req.createDate}
                  </span>
                </div>
              )
            ),
          };
        })}
      />

      {/* Add Requests */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="md">
          <AddEditReq
            {...{
              setShowForm: setShowForm,
              setAlert,
              setList: setReqs,
              unit,
              updData,
              rcdType: 1,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getByObj: actions.getByObj,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(Requests);
